import React from 'react';
import { EasyClaimCaseResponseDto } from 'src/easyclaim.api.client.typescript/src';

interface AdditionalHeaderContentProps {
	easyClaimAttributes?: EasyClaimCaseResponseDto;
}

interface AdditionalHeaderContentState {}

export class AdditionalHeaderContent extends React.Component<
	AdditionalHeaderContentProps,
	AdditionalHeaderContentState
> {
	constructor(props: AdditionalHeaderContentProps) {
		super(props);

		this.state = {};
	}

	render() {
		return (
			<div>
				<div className="additional-header-info">
					<div className="additional-header-info-claim-number">
						{this.props.easyClaimAttributes?.damage?.referenceNumber}
					</div>
					<hr className="additional-header-info-horizontal-line" />
					<div className="additional-header-info-plate-number">
						{this.props.easyClaimAttributes?.vehicle?.platNumber}
					</div>
				</div>
			</div>
		);
	}
}
